// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"63063586","879":"55e23ba7"}[chunkId] + ".chunk.js";
};